import { useMemo } from 'react'

let ONE_HOUR_MS = 60 * 60 * 1000

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let entries = data.map(entry => ({
      id: entry.id,
      action: entry.action,
      created_at: entry.audit_log.sys_created,
      created_by: entry.audit_log.created_by?.person,
    }))

    // Deduplicate NoteModified entries within 1-hour windows per user
    let noteModified = entries.filter(e => e.action === 'NoteModified')
    let other = entries.filter(e => e.action !== 'NoteModified')

    noteModified.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))

    let deduped = []
    let lastByUser = new Map()

    for (let entry of noteModified) {
      let userId = entry.created_by?.id
      if (!userId) {
        deduped.push(entry)
        continue
      }

      let last = lastByUser.get(userId)
      let timeDiff = last
        ? Math.abs(new Date(last.created_at) - new Date(entry.created_at))
        : Infinity

      if (timeDiff >= ONE_HOUR_MS) {
        deduped.push(entry)
        lastByUser.set(userId, entry)
      }
    }

    return [...other, ...deduped].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    )
  }, [data])
}
